import MathUtil from "../../libs/MathUtil";

const { ccclass, property, menu, disallowMultiple } = cc._decorator;

/**
 * 果冻缓动效果*/
@ccclass
@disallowMultiple
@menu('Framework/缓动效果/RotateCloseTo')
export default class RotateCloseTo extends cc.Component {

    @property({type: cc.Node,  tooltip: CC_DEV && '旋转目标点' })
    targetNode: cc.Node = null;

    @property({ tooltip: CC_DEV && '每帧旋转角度' })
    public rotateAngle: number = -8;

    @property({ tooltip: CC_DEV && '旋转帧数' })
    public rotateCount: number = 30;

    private initAngle = 0;
    private initDis = 0;
    private speed = 0;
    private bStartRotate = false;
    private oDis = 0;

    protected start() {
       this.initUI();
    }

    initUI() {
        let p2 = this.node.getPosition();
        let p1 = this.targetNode.getPosition();
        this.initAngle = MathUtil.getAngle2(p2, p1);

        this.oDis = this.initDis = (this.targetNode.position.sub(this.node.position)).mag();
        this.speed = this.initDis/ this.rotateCount;
    }

    setStartRotate(enable: boolean) {
        this.bStartRotate = enable;
    }

    update(dt) {
        if (!this.bStartRotate) {
            return;
        }

        if (this.initDis <= 0) {
            this.bStartRotate = false;
            return;
        }
        this.initAngle += this.rotateAngle;
        this.initDis -= this.speed;

        let x = this.targetNode.position.x + this.initDis * Math.sin(this.initAngle * Math.PI / 180);
        let y = this.targetNode.position.y + this.initDis * Math.cos(this.initAngle * Math.PI / 180);
        this.node.setPosition(cc.v2(x, y));

        // this.node.scale = this.initDis / this.oDis;
    }
}
